module.exports = __webpack_public_path__ + "static/media/mongodb.8f2548d5.svg";